export enum WixmpErrors {
  ResourceNotExists = 'Resource does not exits',
}
